/* eslint-disable-for-generated-file */
/**
 * Generated by orval
 * Do not edit manually.
 * Fireknife API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
    MutationFunction,
    UseMutationOptions,
    UseMutationResult,
} from '@tanstack/react-query';

import type {
    APIErrorResponseResponse,
    TranslateFieldBodyBody,
    TranslateFieldSuccessResponseResponse,
} from '.././model';

import { customInstance } from '.././custom-axios-instance';

/**
 * @summary Translate field title and value
 */
export const translateField = (
    translateFieldBodyBody: TranslateFieldBodyBody,
    signal?: AbortSignal,
) => {
    return customInstance<TranslateFieldSuccessResponseResponse>({
        url: `/translation/translate`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: translateFieldBodyBody,
        signal,
    });
};

export const getTranslateFieldMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof translateField>>,
        TError,
        { data: TranslateFieldBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof translateField>>,
    TError,
    { data: TranslateFieldBodyBody },
    TContext
> => {
    const mutationKey = ['translateField'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof translateField>>,
        { data: TranslateFieldBodyBody }
    > = (props) => {
        const { data } = props ?? {};

        return translateField(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type TranslateFieldMutationResult = NonNullable<Awaited<ReturnType<typeof translateField>>>;
export type TranslateFieldMutationBody = TranslateFieldBodyBody;
export type TranslateFieldMutationError = APIErrorResponseResponse;

/**
 * @summary Translate field title and value
 */
export const useTranslateField = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof translateField>>,
        TError,
        { data: TranslateFieldBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof translateField>>,
    TError,
    { data: TranslateFieldBodyBody },
    TContext
> => {
    const mutationOptions = getTranslateFieldMutationOptions(options);

    return useMutation(mutationOptions);
};
